import { useState, useEffect } from 'react';
import Users from './components/Users';
import Profiles from './components/Profiles';
import AdGroups from './components/AdGroups';
import Login from './components/Login';

export default function App() {
  const [activeTab, setActiveTab] = useState('users');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const storedUsername = localStorage.getItem('username');
    if (token) {
      setIsAuthenticated(true);
      setUsername(storedUsername || '');
    }
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setUsername(localStorage.getItem('username') || '');
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('username');
    setIsAuthenticated(false);
    setUsername('');
  };

  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="app">
      <header className="header">
        <div className="header-left">
          <img src="/learsoft-logo.svg" alt="Learsoft" className="header-logo" />
          <h1>AD Profile Analyzer</h1>
        </div>
        <div className="header-right">
          <span className="header-user">Welcome, {username}</span>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </header>
      <div className="container">
        <div className="tabs">
          <button className={`tab ${activeTab === 'users' ? 'active' : ''}`} onClick={() => setActiveTab('users')}>
            Users
          </button>
          <button className={`tab ${activeTab === 'profiles' ? 'active' : ''}`} onClick={() => setActiveTab('profiles')}>
            Profiles
          </button>
          <button className={`tab ${activeTab === 'groups' ? 'active' : ''}`} onClick={() => setActiveTab('groups')}>
            AD Groups
          </button>
        </div>
        {activeTab === 'users' && <Users />}
        {activeTab === 'profiles' && <Profiles />}
        {activeTab === 'groups' && <AdGroups />}
      </div>
    </div>
  );
}
